import analytics from "../common/analytics/analytics";
import {
  IProductPushable,
  IVehicleDetailsModule,
} from "../common/analytics/analytics.types";

const pushCarouselAnalytics = (
  vehicleAnalytics: IVehicleDetailsModule,
  page: number,
  isEnabled: boolean
) => {
  if (isEnabled) {
    analytics.push<IProductPushable>({
      event: {
        action: "scroll",
        category: "carousel",
        label: `image|${page + 1}`,
        name: "click-search-img-carousel",
        section: "card",
      },
      product: {
        vehicle: [vehicleAnalytics],
      },
    });
  }
};

export default pushCarouselAnalytics;
